//= require jquery/dist/jquery.js
//= require jquery-migrate/dist/jquery-migrate.js
//= require flickity/dist/flickity.pkgd.js
//= require @fancyapps/fancybox/dist/jquery.fancybox.min.js
//= require packery/dist/packery.pkgd.js
//= require blockui/jquery.blockUI.js

window.jQuery = window.$ = require("jquery");
require("jquery-migrate");
require("flickity/dist/flickity.pkgd.js");
require("@fancyapps/fancybox");
require("packery/dist/packery.pkgd.js");
require("blockui/jquery.blockUI");

import HeaderNavContentPush from "./utility/header-nav-content-push";
import {
  isWooCommerceCartPage,
  isWooCommerceCheckoutPage,
} from "./utility/is-page";
import CouponField from "./woocommerce/coupon-field";
import CartItemQuantityField from "./woocommerce/basket/cart-item-quantity-field";
import GiftCardEvents from "./woocommerce/gift-card-events";
import MiniCartCounter from "./woocommerce/basket/mini-cart-counter";

var tabletDtBreakpoint = 1270;

function masonryGridSizer(targetGrid) {
  let viewWidth = window.innerWidth;
  const $grid = targetGrid;
  let gutterWidth = 20;
  // const sidebarWidth = 239;
  let gridWidth = $grid.width() - gutterWidth;
  let contentWidth;
  let colWidth = gridWidth / 4;
  let smallWidth = (gridWidth - gutterWidth * 3) / 4;
  let bigWidth = (gridWidth - gutterWidth) / 2 + 4;

  // sett content width
  contentWidth = viewWidth;
  // if (viewWidth > tabletDtBreakpoint) { //desktop 2 big or 4 small and there is a sidebar
  //     contentWidth = viewWidth - sidebarWidth;
  // } else if (viewWidth <= tabletDtBreakpoint) {//tablet portrait 1 big or 2 small
  // }

  // set
  if (viewWidth > 950) {
    // its not mobile
    gutterWidth = 20;
    colWidth = gridWidth / 4;
    smallWidth = (gridWidth - gutterWidth * 3) / 4;
    bigWidth = (gridWidth - gutterWidth * 2) / 2; // may need to remove the + 9 in the future
  } else {
    // its mobile
    gutterWidth = 20;
    colWidth = gridWidth / 2;
    smallWidth = (gridWidth - gutterWidth * 3) / 2;
    bigWidth = gridWidth - gutterWidth * 2;
  }

  if (viewWidth > 950) {
    $grid.find(".gi-1x1").css("width", smallWidth + "px");
    $grid.find(".gi-2x1").css("width", bigWidth + "px");
    $grid.find(".gi-2x2").css("width", bigWidth + "px");
    $grid.find(".gi-4x2").css("width", gridWidth - gutterWidth + "px");
    $grid.find(".shipping-box").css("width", bigWidth + "px");
  } else {
    $grid.find(".gi-1x1").css("width", "100%");
    $grid.find(".gi-2x1").css("width", "100%");
    $grid.find(".gi-2x2").css("width", "100%");
    $grid.find(".gi-4x2").css("width", "100%");
    $grid.find(".shipping-box").css("width", "100%");
  }

  $grid.packery({
    // options
    horizontalOrder: true,
    itemSelector: ".grid-item",
    columnWidth: colWidth,
  });

  $(".loading-indicator").addClass("hide-indicator");
  targetGrid.removeClass("hide-grid");
}

function showDetails(button, target) {
  let viewWidth = window.innerWidth;
  let $button = button;
  let $target = target;
  let openSymbol = $button.find(".open");
  let closeSymbol = $button.find(".close");

  $button.click(function () {
    console.log("show hide ");

    if ($target.css("display") == "none") {
      $target.toggle();
      openSymbol.css("display", "none");
      closeSymbol.css("display", "");

      console.log("opening!");
    } else {
      $target.toggle();
      openSymbol.css("display", "");
      closeSymbol.css("display", "none");

      console.log("closing!");
    }
  });
}

function showAnswer(button, target) {
  let $button = button;
  let $target = target;
  let targetHeight = target.find("p").outerHeight();
  targetHeight += 30;
  console.log("height: ", targetHeight);

  let openSymbol = $button.find(".open");
  let closeSymbol = $button.find(".close");

  if ($target.css("height") == "0px") {
    $target.css("height", targetHeight);
    openSymbol.css("display", "none");
    closeSymbol.css("display", "");
  } else {
    $target.css("height", "0px");
    openSymbol.css("display", "");
    closeSymbol.css("display", "none");
  }
}

function showFootDetails(button, target) {
  let viewWidth = window.innerWidth;
  let $button = button;
  let $target = target;
  let arrow = button.find(".foot__detail-toggler");

  $button.click(function () {
    console.log("click!");

    if (viewWidth < 825) {
      $target.toggle();
      console.log("toggle!");

      if (target.css("display") == "none") {
        console.log("target true rotate 0deg");
        arrow.css("transform", "rotate(0deg)");
        return;
      } else {
        console.log("target false rotate 90deg");
        arrow.css("transform", "rotate(90deg)");
        return;
      }
    }
  });
}

function hideMenu() {
  $(".mobile-menu").css("display", "none");
}

function showMenu() {
  $(".mobile-menu").addClass("mobile-menu__active");
}

function linksMustScroll() {
  let $menu = $(".sidebar__nav-link");
  let viewHeight = window.innerHeight;
  let topPart = $menu.offset();
  let newTop = topPart.top;
  let menuHeight = viewHeight - newTop;
  let linksHeight = menuHeight - 80;

}

document.addEventListener("DOMContentLoaded", () => {
  //footer
  // wholesale enquiries
  showFootDetails($(".first-collapse"), $(".first-detail"));

  // connect and learn
  showFootDetails($(".second-collapse"), $(".second-detail"));

  // product page
  if ($(".show-hide-description-btn").length) {
    //description
    showDetails($(".show-hide-description-btn"), $(".prod-description"));
    // showDetails($(".show-hide-description-btn"), $(".open-close-desc"));
    //delivery info
    showDetails($(".show-hide-deliver-btn"), $(".delivery-details"));
    // showDetails($(".show-hide-deliver-btn"), $(".open-close-deliver"));
  }

  if ($(".show-hide-reviews-btn").length) {
    //reviews
    showDetails($(".show-hide-reviews-btn"), $(".prod-reviews-content"));
  }

  if ($(".show-hide-question-btn").length) {
    $(".show-hide-question-btn").on("click", function () {
      let $button = $(this);
      let $target = $(this).nextAll(".question-answer");
      showAnswer($button, $target);
    });
  }
});

// set inital menu variables.

document.addEventListener("DOMContentLoaded", setGrid);
window.addEventListener("resize", setGrid);
window.addEventListener("load", setGrid);

function setGrid() {
  if ($(".grid-1").length) {
    masonryGridSizer($(".grid-1"));
  }

  if ($(".grid-2").length) {
    masonryGridSizer($(".grid-2"));
  }

  if ($(".grid-3").length) {
    masonryGridSizer($(".grid-3"));
  }

  if ($(window).innerWidth() > 825) {
    $(".first-detail").css("display", "");
    $(".second-detail").css("display", "");
  }
}

function makeItBigger() {
  // console.log("its getting biggererer");

  var $target = $("#lower-carousel");
  var outerContainer = $(".scroll-wrapper");
  var innerContainer = $(".recomend-container");
  var viewWidth = window.innerWidth; // screen width
  var outerContainerWidth = outerContainer.innerWidth(); // scrollable bit width
  var innerContainerWidth = innerContainer.innerWidth(); // content width
  var flickityWidth =
    (outerContainerWidth - innerContainerWidth) / 2 + innerContainerWidth - 100;

  if (viewWidth < 375) {
    $target.css("width", viewWidth - 95 + "px");
  } else if (viewWidth < 400) {
    $target.css("width", viewWidth - 135 + "px");
  } else if (viewWidth < 768) {
    $target.css("width", viewWidth - 150 + "px");
  } else {
    $target.css("width", flickityWidth + "px");
  }
}

$(window).on("resize orientationchange", function () {
  if ($("#lower-carousel").length) {
    makeItBigger();
  }
});

//flickity
document.addEventListener("DOMContentLoaded", () => {
  if ($("#lower-carousel").length) {
    makeItBigger();
  }

  $(".main-carousel").flickity({
    // options
    cellAlign: "left",
    contain: true,
    groupCells: true,
  });

  $(".top-carousel").flickity({
    // options
    cellAlign: "left",
    contain: true,
    wrapAround: true,
  });

  let $carouselCells = $(".top-carousel").find(".carousel-cell");

  if ($carouselCells.length < 2) {
    $(".top-carousel").addClass("is-hiding-nav-ui");
  }
});

/**
 * Initialises utilities & components
 */
document.addEventListener("DOMContentLoaded", () => {
  // Updates counter in mini cart
  MiniCartCounter.init();

  /**
   * Basket page actions
   */
  if (isWooCommerceCartPage()) {
    // Adds top padding to <body> element to make up for header nav's "fixed" positioning
    HeaderNavContentPush.init();

    CouponField.init();
    CouponField.initAJAXsetup();

    // Custom quantity field (<select>)
    CartItemQuantityField.init();

    // Reload page if cart is empty
    window.jQuery(document.body).on("wc_cart_emptied", () => {
      window.location.reload();
    });
  } else if (isWooCommerceCheckoutPage()) {

  /**
   * Basket page actions
   */
    // Adds top padding to <body> element to make up for header nav's "fixed" positioning
    HeaderNavContentPush.init();

    CouponField.init();

    GiftCardEvents.init();
  }
});
